// hooks/useOnlineStatus.js
import { useEffect } from 'react';
import { ref, update, onDisconnect, serverTimestamp } from 'firebase/database';
import { rtdb } from '../FirebaseConfig/firebase';

export const useOnlineStatus = () => {
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) return;

    let user;
    try {
      user = JSON.parse(storedUser);
    } catch {
      return;
    }

    const userId = user.id || user._id;
    if (!userId) return;

    const userStatusRef = ref(rtdb, `onlineStatus/${userId}`);

    const goOnline = () => {
      update(userStatusRef, {
        online: true,
        lastSeen: null,
        typing: false,
        name: user.name || `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email?.split("@")[0],
        email: user.email || "",
        profilePic: user.profilePic || "",
        userId: userId,
        updatedAt: Date.now(),
      });
    };

    const goOffline = () => {
      update(userStatusRef, {
        online: false,
        lastSeen: serverTimestamp(),
        typing: false,
      });
    };

    goOnline();

    // Step 1: Get the OnDisconnect instance
    const disconnectRef = onDisconnect(userStatusRef);

    // Step 2: Set the disconnect operation
    disconnectRef.set({
      online: false,
      lastSeen: serverTimestamp(),
      lastOnline: serverTimestamp(),
    }).catch(err => {
      console.error("Failed to set onDisconnect:", err);
    });

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        goOnline();
      } else {
        goOffline();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);

      // Step 3: Cancel the onDisconnect operation using the instance
      disconnectRef.cancel().catch(err => {
        // Ignore error if already disconnected or canceled
        if (err.code !== 'PERMISSION_DENIED') {
          console.error("Failed to cancel onDisconnect:", err);
        }
      });

      goOffline();
    };
  }, []);
};